export enum SPONSORSHIP_AGREEMENT_MODAL_STEPS {
    MAILING_ADDRESS_CONFIRMATION = 'mailing-address-confirmation',
    HANG_TIGHT = 'hang-tight',
}
